import React from 'react';
import { useLocation } from 'react-router-dom';
import { Alert } from '@ver-uds/uswds-react';
import AlertConstants from '../../constants/AlertConstants';

type CancelTerminationSuccessState = { cancelTerminationSuccess: boolean };
const CancelTerminationSuccessAlert = (): JSX.Element => {
  const location = useLocation();
  const cancelTerminationSuccess =
    location.state &&
    typeof location.state === 'object' &&
    (Object(location.state) as CancelTerminationSuccessState)?.cancelTerminationSuccess;

  // Removed from state on refresh
  if (cancelTerminationSuccess) {
    window.history.replaceState(undefined, '');
  }

  return cancelTerminationSuccess ? (
    <Alert status="success" slim>
      <Alert.Text>{AlertConstants.CANCEL_TERMINATION_SUCCESS}</Alert.Text>
    </Alert>
  ) : (
    <></>
  );
};

export default CancelTerminationSuccessAlert;
